import APIService from "./APIService";

const SimulationProfileAPI = {
  getSimulationProfilesByUuid: async (uuid) => {
    // If UUID is provided, fetch profile for specific user, otherwise use logged-in user
    const endpoint = uuid
      ? `/api/v1/simulation/profiles/user/${uuid}`
      : `/api/v1/simulation/profiles/user`;
    return APIService.get(endpoint);
  },

  createSimulationProfile: async (data) => {
    return APIService.post(`/api/v1/simulation/profiles`, data);
  },

  /**
   * Update the authenticated user's own simulation profile.
   * Uses auth-context-based endpoint (no numeric ID in URL).
   */
  updateSimulationProfile: async (data) => {
    return APIService.put(`/api/v1/simulation/profiles/user`, data);
  },

  createOrUpdateSimulationProfile: async (data) => {
    try {
      // First, try to get existing profile by user UUID
      const existingProfile =
        await SimulationProfileAPI.getSimulationProfilesByUuid(data.uuid);

      if (existingProfile) {
        // Update existing profile — no numeric ID needed, uses auth context
        console.log("Updating existing profile via auth-context endpoint");
        return await SimulationProfileAPI.updateSimulationProfile(data);
      } else {
        // Create new profile
        console.log("Creating new profile");
        return await SimulationProfileAPI.createSimulationProfile(data);
      }
    } catch (error) {
      console.error("Error in createOrUpdateSimulationProfile:", error);

      // Only fallback to create if we got a 404 (no existing profile)
      if (error.response && error.response.status === 404) {
        console.log("No existing profile found (404), creating new one");
        return await SimulationProfileAPI.createSimulationProfile(data);
      } else {
        // For other errors, don't attempt to create as it might cause duplicates
        throw error;
      }
    }
  },
};

export default SimulationProfileAPI;
